/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './person-name.reducer';

export const PersonName = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const personNameList = useAppSelector(state => state.personName.entities);
  const loading = useAppSelector(state => state.personName.loading);
  const totalItems = useAppSelector(state => state.personName.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="person-name-heading" data-cy="PersonNameHeading">
        <Translate contentKey="tinyMedicRestApp.personName.home.title">Person Names</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.personName.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/person-name/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.personName.home.createLabel">Create new Person Name</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.personName.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {personNameList && personNameList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.personName.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('preferred')}>
                  <Translate contentKey="tinyMedicRestApp.personName.preferred">Preferred</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('preferred')} />
                </th>
                <th className="hand" onClick={sort('givenName')}>
                  <Translate contentKey="tinyMedicRestApp.personName.givenName">Given Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('givenName')} />
                </th>
                <th className="hand" onClick={sort('prefix')}>
                  <Translate contentKey="tinyMedicRestApp.personName.prefix">Prefix</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('prefix')} />
                </th>
                <th className="hand" onClick={sort('middleName')}>
                  <Translate contentKey="tinyMedicRestApp.personName.middleName">Middle Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('middleName')} />
                </th>
                <th className="hand" onClick={sort('familyNamePrefix')}>
                  <Translate contentKey="tinyMedicRestApp.personName.familyNamePrefix">Family Name Prefix</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('familyNamePrefix')} />
                </th>
                <th className="hand" onClick={sort('familyName')}>
                  <Translate contentKey="tinyMedicRestApp.personName.familyName">Family Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('familyName')} />
                </th>
                <th className="hand" onClick={sort('familyNameSufix')}>
                  <Translate contentKey="tinyMedicRestApp.personName.familyNameSufix">Family Name Sufix</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('familyNameSufix')} />
                </th>
                <th className="hand" onClick={sort('familyName2')}>
                  <Translate contentKey="tinyMedicRestApp.personName.familyName2">Family Name 2</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('familyName2')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.personName.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('created')}>
                  <Translate contentKey="tinyMedicRestApp.personName.created">Created</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('created')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.personName.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.personName.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('totalReading')}>
                  <Translate contentKey="tinyMedicRestApp.personName.totalReading">Total Reading</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('totalReading')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.personName.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.personName.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.personName.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.personName.doctor">Doctor</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.personName.pharmacist">Pharmacist</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.personName.diaglabAssistant">Diaglab Assistant</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.personName.hospitalAssistant">Hospital Assistant</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {personNameList.map((personName, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/person-name/${personName.id}`} color="link" size="sm">
                      {personName.id}
                    </Button>
                  </td>
                  <td>{personName.preferred ? 'true' : 'false'}</td>
                  <td>{personName.givenName}</td>
                  <td>{personName.prefix}</td>
                  <td>{personName.middleName}</td>
                  <td>{personName.familyNamePrefix}</td>
                  <td>{personName.familyName}</td>
                  <td>{personName.familyNameSufix}</td>
                  <td>{personName.familyName2}</td>
                  <td>{personName.active ? 'true' : 'false'}</td>
                  <td>{personName.created ? <TextFormat type="date" value={personName.created} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{personName.microSec}</td>
                  <td>{personName.timestampentry}</td>
                  <td>{personName.totalReading}</td>
                  <td>{personName.lastupdated}</td>
                  <td>{personName.cursor}</td>
                  <td>{personName.patient ? <Link to={`/gluco-user/${personName.patient.id}`}>{personName.patient.id}</Link> : ''}</td>
                  <td>{personName.doctor ? <Link to={`/doctor/${personName.doctor.id}`}>{personName.doctor.id}</Link> : ''}</td>
                  <td>
                    {personName.pharmacist ? <Link to={`/pharmacist/${personName.pharmacist.id}`}>{personName.pharmacist.id}</Link> : ''}
                  </td>
                  <td>
                    {personName.diaglabAssistant ? (
                      <Link to={`/diaglab-assistant/${personName.diaglabAssistant.id}`}>{personName.diaglabAssistant.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {personName.hospitalAssistant ? (
                      <Link to={`/hospital-assistant/${personName.hospitalAssistant.id}`}>{personName.hospitalAssistant.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/person-name/${personName.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/person-name/${personName.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/person-name/${personName.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.personName.home.notFound">No Person Names found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={personNameList && personNameList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PersonName;
